import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.section`
	display: flex;
	align-items: center;
	justify-content: space-between;
	row-gap: 64px;
	flex-direction: column;
	background-color: ${helpers.color.primaryTranslucent};
	padding: 64px 32px 32px;
	border-top: 1px solid ${helpers.color.primaryContrast};
	min-height: 300px;
`
